import { query, queryAll } from '../lib/query';
import { getSessionToken, getUid } from '../lib/searchQuery';
import { redirect } from '../lib/redirect';
import { closeUiDialog, showBMDialog } from './dialog';
import hofCookie, { QS_PARAMS } from '../lib/cookie-data';

export default class Dom {
	constructor() {
		this.#fontSizeChanger();
		this.#sameHeightArticlesHolder();
		this.#pinSidebar();
		this.#faqQuestion();
		this.#prime();
		this.#fromMainFile();
	}

	/**
	 * Pins the sidebar to the top of the viewport when scrolling.
	 */
	#pinSidebar() {
		const pinSidebar = () => {
			const fixed_block = query('#sidebar .fixed-block');

			if (window.innerWidth > 768 && fixed_block) {
				const blog_holder = query('.blog-holder');
				const sidebar = query('#sidebar');
				const footer = query('#footer');
				const windowHeight = window.innerHeight;
				const visibleHeight = windowHeight - footer.getBoundingClientRect().top;

				if (window.scrollY > blog_holder.getBoundingClientRect().top) {
					fixed_block.style.position = 'fixed';
					fixed_block.style.top =
						parseInt(window.getComputedStyle(sidebar).paddingTop) + 'px';

					queryAll('.play-options').forEach((element) => {
						element.classList.add('botton-offset');
					});
				} else {
					fixed_block.style.position = '';
					fixed_block.style.top = '';

					queryAll('.play-options').forEach((element) => {
						element.classList.remove('botton-offset');
					});
				}

				if (visibleHeight > 0) {
					fixed_block.style.top = `-${visibleHeight}px`;
				}
			}
		};

		// Pin the sidebar on scroll and resize events
		window.addEventListener('scroll', pinSidebar);
		window.addEventListener('resize', pinSidebar);
	}

	/**
	 * Changes the font size of elements within the main content area.
	 */
	#fontSizeChanger() {
		/**
		 * @param {number} mode
		 * @param {HTMLElement} el
		 */
		const toggleSize = (mode, el) => {
			queryAll('main *').forEach((element) => {
				if (element.children.length === 0) {
					const k = parseInt(window.getComputedStyle(element).fontSize);
					if (k) {
						const redSize = mode === 1 ? k + 2 : k - 2;
						element.style.fontSize = `${redSize}px`;
						el.classList.toggle('low', mode === 1);
					}
				}
			});
		};

		/**
		 * @type {HTMLAnchorElement|null}
		 */
		const textSize = query('a.text-size');

		textSize?.addEventListener('click', (e) => {
			e.preventDefault();
			toggleSize(!textSize.classList.contains('low') ? 1 : 0, textSize);
		});
	}

	/**
	 * Sets the same height for all article holders in the slider.
	 */
	#sameHeightArticlesHolder() {
		const heightArr = [];
		setTimeout(() => {
			queryAll('.articles-slider .text-article').forEach((element) => {
				heightArr.push(parseInt(window.getComputedStyle(element).height));
			});

			const bottomHolderMore = query('.bottom-holder-more');

			if (bottomHolderMore) {
				const bhmHeight = parseInt(
					window.getComputedStyle(bottomHolderMore).height
				);

				const maxHeight = Math.max(...heightArr) + bhmHeight;

				const bxViewport = query('.bx-viewport');

				if (bxViewport) {
					bxViewport.style.height =
						parseInt(window.getComputedStyle(bxViewport).height) +
						bhmHeight +
						'px';
				}

				queryAll('.articles-slider .text-article').forEach((element) => {
					element.style.minHeight = `${maxHeight}px`;
				});
			}
		}, 50);
	}

	#faqQuestion() {
		queryAll('.schema-faq-question')?.forEach((element) => {
			element.addEventListener('click', function () {
				this.classList.toggle('active');
				const panel = this.nextElementSibling;
				if (panel.classList.contains('open')) {
					panel.classList.remove('open');
				} else {
					panel.classList.add('open');
				}
			});
		});
	}

	#prime() {
		/**
		 * Sends a POST request to the prime URL with user data and session token.
		 *
		 * @param {string|number} uid - The user ID.
		 * @param {string} sessionToken - The session token.
		 * @param {string} email - The user's email address.
		 */
		const primeFetch = (uid, sessionToken, email) => {
			const data = JSON.stringify({ uid, email });

			const primeUrl = isHofProd
				? 'https://hof-dsa.playtika.com/email-collect-service/api/public/subscribe'
				: 'https://hof-infra-gw-preprod-dsa.playtika.com/email-collect-service/api/public/subscribe';

			const token = isHofProd
				? 'mkflh3fa29yzq2owz0599tjly4k2x2ba'
				: 'a27z1hn2rrsxvl3au10d9gmduf42espb';

			const url = new URL(primeUrl);
			url.searchParams.set('token', token);

			fetch(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					sessionToken,
				},
				body: data,
			}).finally(() => {
				redirect('/on-the-list/', false);
			});
		};

		query('#prime-form')?.addEventListener('submit', (event) => {
			event.preventDefault();

			const form = new FormData(event.target);

			const emailField = form.get('user_email');

			const uID = getUid();
			const sTK = getSessionToken();

			primeFetch(uID, sTK, emailField);
		});
	}

	/**
	 * @TODO add better description and name for this function
	 * Handles the main file operations.
	 */
	#fromMainFile() {
		query('#bm_page')?.addEventListener('click', (e) => {
			const bookmarkURL = currentUrl.href;
			const bookmarkTitle = document.title;

			if (window.sidebar?.addPanel) {
				window.sidebar.addPanel(bookmarkTitle, bookmarkURL, '');
			} else {
				window.external?.AddFavorite
					? window.external.AddFavorite(bookmarkURL, bookmarkTitle)
					: showBMDialog();
			}

			e.preventDefault();
		});

		query('#bm-dialog .ok-btn')?.addEventListener('click', (e) => {
			e.preventDefault();
			closeUiDialog('#bm-dialog');
		});

		//Play button on Free Coins
		queryAll('.page-template-page-free-coins .play-button').forEach(
			(button) => {
				button.addEventListener('click', (e) => {
					e.preventDefault();

					const params = new URLSearchParams({
						c: 'daily_free_coins_hof',
					});

					hofCookie.set(QS_PARAMS, params.toString());
				});
			}
		);
	}
}
